
export type LoggerMiddlewareOpts = {
	logger?: Function,
};

export default function loggerMiddleware(opts?: LoggerMiddlewareOpts) {
	const logger = (opts && opts.logger) || console.log.bind(console, '[RELAY-NETWORK]'); // eslint-disable-line no-console

    return next => req => {
		const query = `${req.relayReqType} ${req.relayReqId}`;

        logger(`Run ${query}`, req);
        return next(req).then(res => {
            if (res.status !== 200) {
				logger(`Status ${res.status}: ${res.statusText} for ${query}`, req, res);
            }

            return res;
        });
    };
}
